module.exports = __webpack_public_path__ + "static/img/son4_active.ef8af927.png";